import { actionCreatorFactory } from "typescript-fsa";
import { userdata } from "../typing/table_typing";


const actionCreator = actionCreatorFactory("BREADCRUMP");

 const setCrumbs = actionCreator<{entry:userdata, link:userdata}>("BREADCRUMP_RESETDATA");
 const setDeleteItem = actionCreator<{setDeleteItem:string}>("BREADCRUMP_DELETEDATA");

 export const BreadCrumpActions = { setCrumbs, setDeleteItem}


